// extracted by mini-css-extract-plugin
export default {"tooltip":"wP-z","arrow":"xP-z"};